<template>
  <div class="modal-card">
    <div class="row-width-actions-bar">
      <div class="columns is-gapless is-vcentered is-border-bottom">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">{{ params.title || 'Documents' }}</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <section class="modal-card-body">
      <div class="notification is-warning is-marginless is-margin-bottom is-min-height-75 is-flex">
        <div class="is-self-centered w100 is-uppercase is-size-7 has-text-weight-medium">
          Les données des parkings s'administrent sur le lot. Vous pouvez selectionner ou déselectionner les parkings.
        </div>
      </div>
      <form class="">
        <div
          v-for="(parking, idx) in lotParkings"
          :key="idx"
          class="is-border-top column has-background-white is-padding-left is-padding-right ">
          <div class="columns is-gapless is-vcentered is-minH50p">
            <div class="column is-padding-right">
              <span>
                <b class="is-size-6">{{ parking.nature | lotTypeLabel }} :</b>&nbsp;
                <span
                  class="is-size-6"
                  v-for="(type, i ) in parking.parking_type"
                  :key="'type' + i">{{ i > 0 ? ', ' : '' }}{{ type | lotSubtypeLabel }}</span>&nbsp;
                <span
                  class="is-size-6"
                  v-if="parking.info">({{ parking.info }})</span>&nbsp;
                <span
                  class="is-size-6"
                  v-for="(sale_mode, i ) in parking.sales_mode"
                  :key="'sale_mode' + i">{{ i > 0 ? ', ' : '' }}{{ sale_mode | salesmodeLabel }}</span>
                <span v-if="parking.sale_price_ttc"> - {{ parking.sale_price_ttc }} €</span>
              </span>
            </div>
            <div class="column is-narrow">
              <div class="field">
                <input
                  type="checkbox"
                  :id="'check_parking' + idx"
                  :value="'check_parking' + idx"
                  v-model="checkParking[parking.pk]"
                  class="switch is-rounded is-success">
                <label :for="'check_parking' + idx">&nbsp;</label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
    <div class="formActionsSticky is-bottom">
      <div class=" columns is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small">
        <div class="column is-4 is-3-widescreen is-margin-right-small">
          <a
            @click="close()"
            class="button is-light is-uppercase is-fullwidth">
            <span>Annuler</span>
          </a>
        </div>
        <div class="column is-4 is-3-widescreen is-margin-left-small">
          <button
            @click="submit"
            class="button is-success is-uppercase is-fullwidth has-text-white"
            type="submit">
            <span>Valider</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { DefaultValues } from '@/mixins'
export default {
  name: 'ParkingEditModal',
  mixins: [DefaultValues],
  props: {
    active: {
      type: Boolean,
      required: true
    },
    source: {
      type: Object,
      required: true
    },
    params: {
      type: Object
    }
  },
  data () {
    return {
      checkParking: {},
      open: {},
      parkings: [],
      lotParkings: [],
      viewId: Math.random().toString(16).slice(2, 8)
    }
  },
  computed: {
    validParkings () {
      if (this.lot && this.lot.parkings && this.lot.parkings.length) {
        return !this.lot.parkings.find(x => {
          return !x.parking_type || x.sale_price_ttc === '' || !x.sale_price_ttc || x.sale_price_ht === '' || !x.sale_price_ht
        })
      }
      return true
    },
    sourceLotParkings () {
      return this.source.lotParkings
    },
    sourceParkings () {
      return this.source.parkings
    }
  },
  created () {
    this.lotParkings = cloneDeep(this.sourceLotParkings)
    this.parkings = cloneDeep(this.sourceParkings)
    this.initCheckedParkings()
  },
  methods: {
    initCheckedParkings () {
    //   let newReservationParkings = []
      let advParkingsPk = this.parkings.map(x => x.pk)
      for (let parking of this.parkings) {
        this.checkParking[parking.pk] = false
        if (advParkingsPk && advParkingsPk.includes(parking.pk)) {
          this.parkings.map(x => {
            if (x.pk === parking.pk) {
              this.checkParking[parking.pk] = true
            //   newReservationParkings.push(parking)
            }
          })
        }
      }
    //   this.reservation.parkings = newReservationParkings
    },
    close () {
      this.$emit('close')
    },
    submit () {
      let results = {
        newParkings: this.checkParking
      }
      this.$emit('submit', results)
    }
  }
}
</script>
